import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip, Row } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes';
import ModalConfirm from '../subcomponent/modalConfirm';
import SearchItem from '../subcomponent/searchItem';

class Formulariocodigobarras extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear barra",
            msg: 0,
            comp: "",
            id_barra: "",
            empresa: currentCompany,
            cantidad: "",
            codigo_barra: "",
            fija: "0",
            item_descripcion: "",
            item_id: "",
            unidad_id: "",
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: "",
            items: [],
            unidades: []
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_barra = "";
        const barcode = search.replace('?', '');
        if (barcode) {
            titulo = "Modificar barra";
            id_barra = barcode;
        } else {
            titulo = "Crear barra";
            id_barra = "0";
        }

        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/barcode/' + id_barra, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    const info = datos[0];
                    const items = datos[1];
                    const unidades = datos[2];
                    let cantidad = 0;
                    let codigo_barra = "";
                    let fija = "0";
                    let item_descripcion = "";
                    let item_id = "";
                    let unidad_id = "";
                    if (info.length > 0) {
                        cantidad = info[0]["CANTIDAD"];
                        codigo_barra = info[0]["CODIGO_BARRA"];
                        fija = info[0]["CANTIDAD_FIJA"];
                        item_descripcion = info[0]["DESCRIPCION_ITEM"];
                        item_id = info[0]["ID_ITEM"];
                        unidad_id = info[0]["UNIDAD_MEDIDA"];
                    }
                    this.setState({
                        cantidad,
                        codigo_barra,
                        fija,
                        items,
                        item_descripcion,
                        item_id,
                        unidad_id,
                        unidades
                    });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });

        this.setState({ id_barra, titulo });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { empresa } = this.state
        const { cantidad } = this.state
        const { codigo_barra } = this.state
        const { fija } = this.state
        const { item_id } = this.state
        const { unidad_id } = this.state

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: empresa,
                CANTIDAD: cantidad,
                CODIGO_BARRA: codigo_barra,
                CANTIDAD_FIJA: fija,
                ID_ITEM: item_id,
                UNIDAD_MEDIDA: unidad_id
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }

        if (this.state.id_barra === "0") {
            ruta = config.servBackEnd + '/barcode/create';
        } else {
            ruta = config.servBackEnd + '/barcode/modify/' + this.state.id_barra;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoImpuesto = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_barra;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_barra: nuevoImpuesto })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "codigo de barra con errores:" + errores[data.code] + " " + data.message })
                }
            });
        event.preventDefault();
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    addItem = (item) => {
        const item_descripcion = item.DESCRIPCION_ITEM;
        const item_id = item.ID_ITEMS;
        this.setState({
            item_descripcion,
            item_id
        })
    }

    render() {
        const mensajeBoton = (this.state.id_barra === "0") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_barra === "0") ? '¿Esta seguro que desea crear el codigo de barras?' : '¿Esta seguro que desea modificar el codigo de barras?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const { unidades } = this.state;
        return (
            <div className="Formulariocodigobarras">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a listado de codigos!</Tooltip>}>
                            <div className="div-back">
                                <a href="/barras/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>
                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Row>
                                        <Col>
                                            <SearchItem clean={true} data={this.state.items} event={this.addItem} ></SearchItem>
                                        </Col>
                                        <Col>
                                            <Form.Group as={Row}>
                                                <Form.Label>ITEM ASOCIADO</Form.Label>
                                                <Form.Control type="text" value={this.state.item_descripcion} readOnly />
                                            </Form.Group>
                                            <Form.Group as={Row}>
                                                <Form.Label>TIPO CANTIDAD</Form.Label>
                                                <Form.Control as="select" onChange={e => this.setState({ fija: e.target.value })} value={this.state.fija} required >
                                                    <option value="1">FIJA</option>
                                                    <option value="0">EDITABLE</option>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Row}>
                                                <Form.Label>UNIDAD</Form.Label>
                                                <Form.Control as="select" onChange={e => this.setState({ unidad_id: e.target.value })} value={this.state.unidad_id} required >
                                                    <option value="">Seleccione</option>
                                                    {
                                                        unidades.map((element, i) => {
                                                            return (
                                                                <option key={i} value={element.ID_UNIDADES}>{element.DESCRIPCION_UNIDAD}</option>
                                                            )
                                                        })
                                                    }
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Row}>
                                                <Form.Label>CANTIDAD</Form.Label>
                                                <Form.Control type="number" onChange={e => this.setState({ cantidad: e.target.value })} value={this.state.cantidad} required />
                                            </Form.Group>
                                            <Form.Group as={Row}>
                                                <Form.Label>CODIGO DE BARRAS</Form.Label>
                                                <Form.Control type="text" onChange={e => this.setState({ codigo_barra: e.target.value })} value={this.state.codigo_barra} required />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formulariocodigobarras);